// tienda/CtaBanner.jsx

import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, MessageCircle } from "lucide-react";
import { brand, WA_HREF } from "../shared/brand";

export function CtaBanner() {
  return (
    <section className="relative overflow-hidden" style={{ background: brand.ink }}>
      <div
        className="absolute inset-0 opacity-70"
        style={{
          background:
            `radial-gradient(circle at 20% 20%, ${brand.primary}66, transparent 34%),` +
            `radial-gradient(circle at 80% 0%, ${brand.accentGreen}55, transparent 30%)`,
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 py-14 text-center text-white md:py-16">
        <h3 className="mx-auto max-w-2xl text-3xl font-black md:text-4xl">
          Convierte tus entregas en una ventaja para vender más.
        </h3>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/75 md:text-base">
          Crea tu cuenta, agenda tu primer recojo y empieza a operar con seguimiento,
          WhatsApp automático y contraentrega desde el primer día.
        </p>
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-black text-white"
            style={{ background: brand.primary }}
          >
            Crear cuenta gratis
            <ChevronRight className="size-4" />
          </Link>
          <a
            href={WA_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/25 px-5 py-3 text-sm font-black text-white transition-colors hover:bg-white/10"
          >
            <MessageCircle className="size-4" />
            Hablar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
